'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyle = function baseStyle(props) {
  var c = props.colorScheme;
  return {
    color: c ? "".concat(c, ".400") : null,
    display: 'inline-block',
    mt: 2
  };
};
var defaultProps = {
  colorScheme: 'red'
};
var Feedback = {
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
exports["default"] = Feedback;